<template>
    <div class="row pattern">
            <section class="wallpapers" id="wallpapers">
                <viewer :options="options" @inited="inited">
                    <div class="container">
                        <div class="row">
                            <h2>Wallpapers</h2>
                        </div>
                        <div class="row items-container" >
                            <div class="col-xs-5 gallery-item item-1 thumbnail-50" @click="show(0)">
                                <img src="@/assets/wallpapers/CentralVeins-800-450.jpg" data-source="https://downloads.embersadrift.com/wallpapers/CentralVeins.jpg" key="CentralVeins.jpg" class="image" alt="Central Veins">
                            </div>
                            <div class="col-xs-5 col-xs-offset-2 gallery-item item-2 thumbnail-50" @click="show(1)">
                                <img src="@/assets/wallpapers/DryfootFallows-800-450.jpg" data-source="https://downloads.embersadrift.com/wallpapers/DryfootFallows.jpg" key="DryfootFallows.jpg" class="image" alt="Dryfoot Fallows">
                            </div>
                        </div>
                        <div class="row items-container" >
                            <div class="col-xs-5 gallery-item item-1 thumbnail-50" @click="show(2)">
                                <img src="@/assets/wallpapers/ElementsOfEmber-800-450.jpg" data-source="https://downloads.embersadrift.com/wallpapers/ElementsOfEmber.jpg" key="ElementsOfEmber.jpg" class="image" alt="Elements of Ember">
                            </div>
                            <div class="col-xs-5 col-xs-offset-2 gallery-item item-2 thumbnail-50" @click="show(3)">
                                <img src="@/assets/wallpapers/GrizzledPeaks-800-450.jpg" data-source="https://downloads.embersadrift.com/wallpapers/GrizzledPeaks.jpg" key="GrizzledPeaks.jpg" class="image" alt="Grizzled Peaks">
                            </div>
                        </div>
                        <div class="row items-container" >
                            <div class="col-xs-5 gallery-item item-1 thumbnail-50" @click="show(4)">
                                <img src="@/assets/wallpapers/NewHavenCity-800-450.jpg" data-source="https://downloads.embersadrift.com/wallpapers/NewHavenCity.jpg" key="NewHavenCity.jpg" class="image" alt="Newhaven City">
                            </div>
                            <div class="col-xs-5 col-xs-offset-2 gallery-item item-2 thumbnail-50" @click="show(5)">
                                <img src="@/assets/wallpapers/TheGreatChasm-800-450.jpg" data-source="https://downloads.embersadrift.com/wallpapers/TheGreatChasm.jpg" key="TheGreatChasm.jpg" class="image" alt="The Great Chasm">
                            </div>
                        </div>
                        <div class="row items-container" >
                            <div class="col-xs-5 gallery-item item-1 thumbnail-50" @click="show(6)">
                                <img src="@/assets/wallpapers/TheOldWall-800-450.jpg" data-source="https://downloads.embersadrift.com/wallpapers/TheOldWall.jpg" key="TheOldWall.jpg" class="image" alt="The Old Wall">
                            </div>
                            <div class="col-xs-5 col-xs-offset-2 gallery-item item-2 thumbnail-50" @click="show(7)">
                                <img src="@/assets/wallpapers/Highlands-800-450.jpg" data-source="https://downloads.embersadrift.com/wallpapers/Highlands.jpg" key="Highlands.jpg" class="image" alt="Highlands">
                            </div>
                        </div>
                    </div>
                </viewer>
                <div class="row items-container" >
                    <div class="center-button">
                        <a xmlns="http://www.w3.org/1999/xhtml" class="button-game" href="https://downloads.embersadrift.com/wallpapers/Embers-Adrift-Wallpapers-2022.zip">
                                <span class="button-game-bg-left"></span>
                                <span class="button-game-bg-mid">
                                    <span>Download All</span>
                                </span>
                                <span class="button-game-bg-right"></span>
                            </a>
                    </div>
                </div>
            </section>
        </div>
</template>
<script>
  import 'viewerjs/dist/viewer.css'
  import Viewer from "v-viewer/src/component.vue"

  export default {
    name: 'WallpapersComponent',
    components: { Viewer },
    data() {
      return {
        options: {
            toolbar: false,
            navbar: false,
            url: 'data-source'
        }
      }
    },
    methods: {
        inited (viewer) {
            this.$viewer = viewer
        },
        show (i) {
            this.$viewer.view(i)
        }
    }
  }
</script> 